import { API_END_POINTS } from "../../constant/config";
import JsonInterceptor from "../../utils/JsonInterceptor";
import { CREATE_CART, DELETE_CART, GET_CART, GET_SINGLE_CART, UPDATE_CART } from "../type";

// Fetch Cart Pricing
export const fetchCartDataPricing = (query) => async (dispatch) => {
    try {
        const apiEndpoint = `${API_END_POINTS.FETCH_CART}`;
        const response = await JsonInterceptor.get(`${apiEndpoint}`)

        dispatch({
            type: GET_CART,
            payload: response.data.data,
        });
    } catch (error) {
        console.log("error", error);
    }
};

// Create Cart-Priccing
export const createCartPricing = (data) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.CREATE_CART;
        const response = await JsonInterceptor.post(`${apiEndpoint}`, data)
        return dispatch({
            type: CREATE_CART,
            payload: response.data,
        });
    } catch (error) {
        if (error.response) {
            return dispatch({
                type: CREATE_CART,
                payload: error.response.data,
            });
        }
    }
};

// Get Single Cart pricing
export const fetchSingleCart = (id) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.FETCH_SINGLE_CART;
        const response = await JsonInterceptor.get(`${apiEndpoint}/${id}`,)
        dispatch({
            type: GET_SINGLE_CART,
            payload: response.data.data,
        });
    } catch (error) {
        console.log("error", error);
    }
};

// Update Cart pricing
export const updateCartPricing = (data, id) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.UPDATE_CART;
        const response = await JsonInterceptor.put(`${apiEndpoint}/${id}`, data)
        return dispatch({
            type: UPDATE_CART,
            payload: response.data,
        });
    } catch (error) {
        if (error.response) {
            return dispatch({
                type: UPDATE_CART,
                payload: error.response.data,
            });
        }
    }
};

// Delete Cart Pricing
export const deleteCartPricing = (id) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.DELETE_CART;
        const response = await JsonInterceptor.delete(`${apiEndpoint}/${id}`)
        dispatch({
            type: DELETE_CART,
        });
    } catch (error) {
        console.log("error", error);
    }
};